import AuthorizedRoute from 'base-shell/lib/components/AuthorizedRoute';
import React, { lazy } from 'react';
import UnauthorizedRouteV2 from './auth/UnauthorizedRouteV2';
const LandingPage = lazy(() => import('../pages/LandingPage'));
const SignIn = lazy(() => import('../pages/Signin'));

const PageNotFound = lazy(() => import('../pages/PageNotFound'));

const getDefaultRoutes = (appConfig) => {
  return [
    {
      path: '/signin',
      exact: true,
      element: (
        <UnauthorizedRouteV2>
          <SignIn redirectTo={appConfig?.auth?.redirectTo || '/'} />
        </UnauthorizedRouteV2>
      ),
    },

    {
      path: '/index.htm',
      exact: true,
      element: <LandingPage />,
    },

    {
      path: '/index.html',
      exact: true,
      element: <LandingPage />,
    },

    {
      path: '*',
      element: <PageNotFound />,
    },
  ];
};

export { getDefaultRoutes };
